import { atom } from "jotai";
import { atomFamily } from "jotai-family";
import { PieChartItem } from "./PieChart.types";

export const legendHoverAtomFamily = atomFamily((_key: string) =>
  atom<PieChartItem | undefined>(undefined)
);

export const disabledLegendItemsFamily = atomFamily((_key: string) =>
  atom<Array<PieChartItem>>([])
);
